export default __webpack_public_path__ + "static/media/FKGroteskNeue-Light.72d18702.woff";